<template>
  <v-container id="wizard" tag="section" class="mt-9">
    <template>
      <v-stepper v-model="e1" non-linear>
        <v-stepper-header>
          <v-stepper-step editable step="1">
            <div>
              <v-icon color="indigo darken-1">mdi-clipboard-list</v-icon>Datos
              de la promoción
            </div>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step editable step="2">
            <div>
              <v-icon color="indigo darken-1">mdi-package</v-icon>Producto
              participantes
            </div>
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3" editable>
            <div>
              <v-icon color="indigo darken-1">mdi-calendar</v-icon>Fechas
            </div>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4" editable>
            <div>
              <v-icon color="indigo darken-1">mdi-file-document</v-icon
              >Intrucciones
            </div>
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <!-- DATOS GENERALES -->
          <v-stepper-content step="1">
            <v-container>
              <v-row>
                <v-col cols="12" sm="4">
                  <v-form>
                    <v-layout row wrap justify-start>
                      <v-col cols="auto" sm="11">
                        <v-select
                          :items="getBranchOffices"
                          label="Selecciona la oficina"
                          chips
                          item-text="name"
                          item-value="id"
                          item-key="id"
                          color="indigo"
                          placeholder="Selecciona una o varias sucursales"
                          multiple
                          v-model="branchOfficeId"
                        ></v-select>
                      </v-col>
                      <v-col cols="4" sm="11">
                        <v-text-field
                          name="name"
                          label="Nombre de la promoción"
                          v-model="name"
                          counter
                        >
                          <template v-slot:append>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon color="indigo accent-4" v-on="on"
                                  >mdi-help-circle-outline</v-icon
                                >
                              </template>
                              Nombre con el que se registrara la promoción
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="auto" sm="11">
                        <v-text-field
                          name="Alias"
                          label="Alias de la promoción"
                          v-model="alias"
                        >
                          <template v-slot:append>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon color="indigo accent-4" v-on="on"
                                  >mdi-help-circle-outline</v-icon
                                >
                              </template>
                              Nombre corto con el que se registrara la promoción
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-layout>

                    <v-layout row wrap v-if="account === 0">
                      <v-col cols="12" sm="11">
                        <v-text-field
                          name="monto"
                          label="Ingrese el monto a descontar"
                          v-model="monto"
                          @keypress="KeyEventPress"
                          prepend-inner-icon="mdi-currency-usd"
                        ></v-text-field>
                      </v-col>
                    </v-layout>
                    <v-layout row wrap v-if="account === 1">
                      <v-col cols="12" sm="11">
                        <v-text-field
                          name="percent"
                          label="Ingrese el pocentaje de descuento"
                          hint="El valor de descuento es en %"
                          prepend-inner-icon="mdi-brightness-percent"
                        ></v-text-field>
                      </v-col>
                    </v-layout>
                    <v-layout row wrap v-if="account === 4">
                      <v-col cols="12" sm="6">
                        <v-text-field
                          name="nuno"
                          label="Cantidad uno"
                          v-model="Nuno"
                          @keypress="KeyEventPress"
                          prepend-inner-icon="mdi-numeric-1-box-outline"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          name="ndos"
                          label="Cantidad dos"
                          v-model="Ndos"
                          @keypress="KeyEventPress"
                          prepend-inner-icon="mdi-numeric-2-box-outline"
                        ></v-text-field>
                      </v-col>
                    </v-layout>
                  </v-form>
                </v-col>
                <v-col cols="auto" sm="8">
                  <v-responsive class="mx-auto" max-width="100%">
                    <div
                      class="text-center display-1 grey--text font-weight-light mb-6"
                    >
                      <v-icon color="indigo">mdi-exclamation</v-icon>Elige el
                      tipo de Promoción a registrar
                      <v-icon color="indigo">mdi-exclamation</v-icon>
                    </div>

                    <input :value="settings" type="hidden" />

                    <v-item-group v-model="account" class="row">
                      <v-item
                        v-for="(account, i) in accounts"
                        :key="i"
                        :value="account.id"
                      >
                        <template v-slot="{ active, toggle }">
                          <v-col class="text-center" cols="2">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-card
                                  :class="
                                    active ? 'blue lighten-2' : 'grey lighten-4'
                                  "
                                  class="d-flex align-center mt-n2"
                                  height="80"
                                  v-on="on"
                                  @click="toggle"
                                >
                                  <div
                                    class="display-3 flex-grow-1 text-center"
                                  >
                                    <v-icon
                                      :color="active ? 'white' : 'blue'"
                                      large
                                      >{{ account.icon }}</v-icon
                                    >
                                  </div>
                                </v-card>
                              </template>
                              <span class="font-weight-bold">{{
                                account.desc
                              }}</span>
                            </v-tooltip>

                            <div
                              class="small font-weight-light grey--text"
                              v-text="account.type"
                            />
                          </v-col>
                        </template>
                      </v-item>
                    </v-item-group>
                  </v-responsive>
                </v-col>
              </v-row>
            </v-container>
            <v-btn color="primary" @click="e1 = 2">Siguiente</v-btn>
          </v-stepper-content>
          <!-- PRODUCTOS -->
          <v-stepper-content step="2">
            <v-container>
              <v-data-table
                v-model="selected"
                :headers="headers"
                :search.sync="search"
                :items="listProducts"
                :single-select="singleSelect"
                item-key="name"
                show-select
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-container>
                    <v-row no-gutters>
                      <v-col cols="12" sm="12" md="4">
                        <v-layout>
                          <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            hide-details
                            single-line
                            color="indigo accent-4"
                          ></v-text-field>
                        </v-layout>
                      </v-col>

                      <v-col cols="12" sm="12" md="4" class="pl-8">
                        <v-select
                          v-model="unit"
                          multiple
                          hide-no-data
                          item-text="name"
                          item-value="name"
                          :items="Categorias"
                          label="Filtrar por Categorías "
                        ></v-select>
                      </v-col>
                      <!-- <v-col cols="12" sm="3" class="pl-8">
                        <v-select
                          v-model="Tags"
                          multiple
                          item-value="id"
                          item-text="name"
                          :items="Etiquetas"
                          label="Filtrar por Etiquetas "
                        ></v-select>
                      </v-col> -->
                      <v-col cols="12" sm="6" md="3">
                        <v-layout row wrap justify-end>
                          <v-btn
                            @click="FilterData()"
                            max-width="90"
                            small
                            color="indigo darken-3"
                            >Buscar</v-btn
                          >
                          <v-btn
                            max-width="90"
                            small
                            color="orange darken-3"
                            @click="CleanData"
                            >Limpiar</v-btn
                          >
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <template v-slot:item.price="{ item }">{{
                  SetCoin(item.price)
                }}</template>
              </v-data-table>
            </v-container>

            <v-btn color="red" text @click="e1 = 1">Volver</v-btn>
            <v-btn color="primary" @click="e1 = 3">Continue</v-btn>
          </v-stepper-content>
          <!-- FECHAS -->
          <v-stepper-content step="3">
            <v-container>
              <v-layout row wrap justify-center>
                <div class="font-weight-medium grey--text display-1">
                  Selecciona el rango de fechas disponible para la promoción
                </div>
              </v-layout>
              <v-row>
                <v-row no-gutters>
                  <v-col cols="10" sm="12" md="6" lg="6" xl="6">
                    <div class="text-center mt-3">
                      <vc-date-picker
                        v-model="dates"
                        is-expanded
                        :min-date="new Date()"
                        mode="range"
                        :attributes="attrs"
                        is-inline
                        :columns="$screens({ default: 3 })"
                      />
                    </div>
                  </v-col>
                  <v-col
                    cols="10"
                    sm="12"
                    md="6"
                    lg="6"
                    xl="6"
                    class="mt-3 ml-1"
                  >
                    <v-sheet color="grey lighten-4">
                      <span class="display-1 font-weight-bold text-center"
                        >Horario disponible para promoción</span
                      >
                      <v-data-table
                        :headers="headerHorario"
                        :items="itemsHorario"
                        hide-default-footer
                        disable-pagination
                        fixed-header
                        dense
                        no-data-text="No hay horarios registrados"
                      >
                        <template v-slot:item.startTime="props">
                          <v-menu
                            :ref="`menu${props.item.index}`"
                            v-model="props.item.menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="props.item.startTime"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="props.item.startTime"
                                label="Horario de Inicio"
                                readonly
                                v-on="on"
                              >
                                <template v-slot:append-outer>
                                  <v-tooltip
                                    bottom
                                    max-width="200"
                                    color="indigo darken-3"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="indigo darken-3" v-on="on"
                                        >mdi-help-circle</v-icon
                                      >
                                    </template>
                                    <span
                                      >A partir de esta hora la Promoción sera
                                      valida</span
                                    >
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </template>
                            <v-time-picker
                              v-if="props.item.menu"
                              v-model="props.item.startTime"
                              full-width
                              @click:minute="
                                displayRef(
                                  `menu${props.item.index}`,
                                  props.item.startTime
                                )
                              "
                            ></v-time-picker>
                          </v-menu>
                        </template>
                        <template v-slot:item.endTime="props">
                          <v-menu
                            :ref="`menu2${props.item.index}`"
                            v-model="props.item.menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="props.item.endTime"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="props.item.endTime"
                                label="Horario de Finalización"
                                readonly
                                v-on="on"
                              >
                                <template v-slot:append-outer>
                                  <v-tooltip
                                    bottom
                                    max-width="200"
                                    color="indigo darken-3"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="indigo darken-3" v-on="on"
                                        >mdi-help-circle</v-icon
                                      >
                                    </template>
                                    <span>A partir de esta hora la Promoción finalizará</span>
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </template>
                            <v-time-picker
                              v-if="props.item.menu2"
                              v-model="props.item.endTime"
                              full-width
                              @click:minute="
                                displayRef(
                                  `menu2${props.item.index}`,
                                  props.item.endTime
                                )
                              "
                            ></v-time-picker>
                          </v-menu>
                        </template>
                      </v-data-table>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-row>
            </v-container>
            <v-btn color="red" text @click="e1 = 2">Volver</v-btn>
            <v-btn color="primary" @click="e1 = 4">Siguiente</v-btn>
          </v-stepper-content>
          <!-- INSTRUCCIONES -->
          <v-stepper-content step="4">
            <v-container>
              <v-layout row wrap>
                <v-col cols="12" sm="4">
                  <v-text-field
                    name="maxticket"
                    v-model="perTicket"
                    @keypress="KeyEventPress"
                    label="Número de veces por Ticket"
                    prepend-inner-icon="mdi-counter"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="7">
                  <v-combobox
                    v-model="select"
                    :items="items"
                    label="Aplica para otras promociones"
                    multiple
                    class="mt-n1"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                      >
                        <v-avatar
                          class="accent white--text"
                          left
                          v-text="data.item.slice(0, 1).toUpperCase()"
                        ></v-avatar>
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-col>
              </v-layout>
              <v-layout row wrap>
                <v-textarea
                  v-model="intrucciones"
                  auto-grow
                  filled
                  color="primary"
                  label="Instrucciones Para aplicar la promoción "
                  rows="1"
                ></v-textarea>
              </v-layout>
              <v-row>
                <div class="flex-grow-1"></div>
                <v-btn @click="GuardarPromo()" color="green darken-3" outlined
                  >Guardar</v-btn
                >
              </v-row>
            </v-container>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </v-container>
</template>
<script>
import moment from "moment";
import _ from "lodash";

import axios from "axios";
export default {
  name: "DashboardFormsWizard",
  watch: {
    dates(values) {
      var startDate = moment(moment(values.start).format("YYYY-MM-DD")),
        endDate = moment(moment(values.end).format("YYYY-MM-DD"));

      var getDateArray = function (start, end) {
        var arr = new Array(),
          dt = new Date(start);

        while (dt <= end) {
          arr.push(new Date(dt));
          dt.setDate(dt.getDate() + 1);
        }

        return arr;
      };
      let items = [];
      let dateArr = getDateArray(startDate, endDate);
      _.map(dateArr, function (o, i) {
        items.push({
          index: i + 1,
          date: moment(o).format("YYYY-MM-DD"),
          startTime: "",
          endTime: "",
          menu: false,
          menu2: false,
        });
      });
      this.itemsHorario = items;
    },
  },
  created() {
    const b = this.Categorias;
    if (b.length === 0) {
      this.loadCategorias();
    }
  },
  mounted() {
    const v = this.desserts;
    if (v.length === 0) {
      this.loadProducts();
    } else {
      this.listProducts = this.desserts;
    }
  },
  data: () => ({
    branchOfficeId: [],
    time: null,
    menu2: false,
    time: null,
    menuOut: false,
    timeOut: null,
    intrucciones: "",
    select: [],
    perTicket: "",
    porcentaje: "",
    Nuno: "",
    Ndos: "",
    monto: "",
    dates: null,
    items: [],
    listProducts: [],
    headerHorario: [
      {
        text: "Fecha",
        value: "date",
        align: "left",
      },
      {
        text: "Hora inicio",
        value: "startTime",
        align: "center",
      },
      {
        text: "Hora fin",
        value: "endTime",
        align: "center",
      },
    ],
    itemsHorario: [],
    attrs: [
      {
        key: "today",
        highlight: true,
        dates: new Date(),
      },
    ],
    picker: [
      new Date().toISOString().substr(0, 10),
      new Date().toISOString().substr(0, 10),
    ],
    e1: 0,
    valid: false,
    name: "",
    alias: "",
    settings: [],
    search: null,
    selected: [],
    unit: [],
    Tags: [],
    singleSelect: false,
    headers: [
      {
        text: "Código",
        align: "left",
        value: "code",
      },
      {
        text: "Nombre",
        align: "left",
        value: "name",
      },
      {
        text: "Categoría",
        align: "left",
        value: "category",
      },
      {
        text: "Precio",
        align: "right",
        value: "price",
      },
    ],
    account: [],
    accounts: [
      {
        id: 0,
        icon: "mdi-cash",
        type: "Descuento efectivo",
        desc: "Descuento de una cantidad de efectivo, según las instrucciones",
      },
      {
        id: 1,
        icon: "mdi-percent",
        type: "Descuento Porcentaje",
        desc: "Descuento en un porcentaje del total de compra.",
      },
      {
        id: 2,
        icon: "mdi-numeric-2-circle",
        type: "Promo 2x1",
        desc: "Promoción de 2x1, en la compra de productos participantes",
      },
      {
        id: 3,
        icon: "mdi-numeric-3-circle",
        type: "Promo 3x2",
        desc: "Promoción de 3x2, en la compra de productos participantes",
      },
      {
        id: 4,
        icon: "mdi-alpha-n-box-outline",
        type: "Promo NxN",
        desc: "Usted decide la combinación de esta promo",
      },
      {
        id: 5,
        icon: "mdi-vector-combine",
        type: "Combos",
        desc:
          "Promoción en productos combinados, en la compra de un producto se incluye otro.",
      },
    ],
  }),
  computed: {
    dateRangeText() {
      return this.picker.join(" ~ ");
    },
    desserts() {
      return this.$store.state._Productos;
    },
    Categorias: {
      get() {
        return this.$store.state.Categoria;
      },
      set(val) {
        this.$store.commit("SET_CATEGORIA", val);
      },
    },
    Etiquetas() {
      return this.$store.state.Tags;
    },
    getBranchOffices: {
      get() {
        return this.$store.state.BranchOffice;
      },
      set() {},
    },
  },
  methods: {
    loadCategorias() {
      axios
        .get(`/api/Catalogs/Category`, {
          headers: {
            bussinessId: this.$store.state._bussinessAccountId,
          },
        })
        .then((result) => {
          this.$store.commit("SET_CATEGORIA", result.data);
        });
    },
    loadProducts() {
      axios
        .get("/api/Catalogs/Product/%20", {
          headers: {
            bussinessId: this.$store.state._bussinessAccountId,
          },
        })
        .then((result) => {
          return result.data;
        })
        .then((data) => {
          this.$store.commit("SET_PRODUCTOS", data);
        })
        .catch((err) => {
          this.isLoading = false;
        });
      this.listProducts = this.desserts;
    },
    GuardarPromo() {
      let schedule = [];
      let products = [];
      _.map(this.itemsHorario, (e) => {
        schedule.push({
          date: e.date,
          startTime: e.startTime,
          endTime: e.endTime,
        });
      });

      _.map(this.selected, (e) => {
        products.push({
          id: e.id,
          name: e.name,
          code: e.code,
        });
      });

      const values = {
        name: this.name,
        type: this.account,
        products: JSON.stringify(products),
        startDate: moment(this.dates.start).format("YYYY-MM-DD H:MM:ss"),
        finishDate: moment(this.dates.end).format("YYYY-MM-DD H:MM:ss"),
        schedule: JSON.stringify(schedule),
        instructions: this.intrucciones,
        maxPerTicket: this.perTicket,
        applyWithOthers: this.select,
        image: null,
        branchOffices: this.branchOfficeId,
      };
      axios
        .post("/api/Catalogs/Promo", values, {
          headers: {
            bussinessId: this.$store.state._bussinessAccountId,
          },
        })
        .then((result) => {
          console.log(result);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    displayRef(ref, time) {
      console.log(ref);
      this.$refs[ref].save(time);
    },
    FilterData() {
      let b = [];
      this.listProducts = this.desserts;
      _.flatMap(this.listProducts, (nameObj) =>
        _.map(this.unit, (objVal) => {
          if (nameObj) {
            if (nameObj.category === objVal) {
              b.push(nameObj);
            }
          }

          /*   if () {
            return nameObj;
          } */
        })
      );
      if (this.unit.length === 0) {
        this.listProducts = this.desserts;
      } else {
        this.listProducts = b;
      }
    },
    KeyEventPress($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    getDateArray(obj) {
      var start = obj.startDate.clone();
      console.log(start);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    SetCoin(item) {
      return "$ " + this.formatNumber(parseFloat(item).toFixed(2));
    },
    CleanData() {
      this.unit = [];
      this.Tags = [];
      this.listProducts = this.desserts;
      this.search = "";
    },
  },
};
</script>

<style lang="sass">
.v-card.v-card.v-card--account
  border-color: currentColor
  border-width: 4px

  .v-icon
    color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%
</style>


